import { baseApi } from '@/services/index';

const resource = process.env.VUE_APP_RESOURCE_SICUDDOCUMENTFORINSTANCE;

export default {
  create(payload) {
    return baseApi.post(resource, payload);
  },

  update(payload) {
    return baseApi.put(resource, payload);
  },

  delete(payload) {
    return baseApi.delete(resource, {
      data: payload,
    });
  },
};
